module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAP1BMVEUAAABhYWFmZmZmZmZlZWVlZWVfX19mZmZlZWVlZWVmZmZlZWVjY2NlZWVlZWVlZWVlZWViYmJjY2NkZGRmZmb1vucHAAAAFHRSTlMAH9+An+UX18Wuj1lHTPezpzwkOMIxpA4AAABzSURBVBjTjc/RCoAgDIVhdc4ys9J8/2dtKl0cSuq/cXwwYWrc6vvr11sCkTfUMp4oVDtma2e2La7zIbhlWd/70i7reZOhaAXpMkQ2EDdMGkrlx590PnGZHGCkboBuWqohiooBNnWfF3HQUGDByAXiqF67ADKuBbnRx4pFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/normal_dk.png
// module id = 35Be
// module chunks = 57